export var MF_REGISTRATION_BOOK = "MF_REGISTRATION_BOOK";
